import React, { Fragment, useEffect, useState } from "react";

const EmptyList = (props: any) => {
  const { cellColumns, detailedView } = props;
  return (
    <div
      className={`w-full flex-col ${
        detailedView
          ? "bg-neutral-100 justify-center h-60v"
          : "bg-white justify-start h-80v"
      } items-center gap-3 inline-flex`}
    >
      <div className="self-stretch justify-start items-start inline-flex">
        {cellColumns
          ?.filter((eachCell: any) => eachCell !== " ")
          ?.map((eachCell: any) => (
            <div className="w-full h-12 px-3 py-4 bg-gray-50 justify-center items-center gap-2 flex">
              <div className="text-slate-500 text-sm font-medium">
                {eachCell}
              </div>
            </div>
          ))}
      </div>
      <div className="flex-col justify-center items-center gap-16 flex">
        <div className="w-16 h-16 relative" />
        <div className="flex-col justify-start items-center gap-2 flex">
          <img
            className="pw-no-items w-16"
            src="assets/images/empty.png"
            alt=" "
          />
          {!detailedView && (
            <div>
              <div className="text-center text-neutral-800 text-base font-medium">
                No results found
              </div>
              <div className="text-center text-slate-400 text-sm font-normal leading-tight">
                Try adjusting your search to find what you are looking for
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default EmptyList;
